import { NavLink, Link, useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import Collapse from "bootstrap/js/dist/collapse";

export default function Navbar() {
  const collapseRef = useRef(null);
  const bsCollapseRef = useRef(null);
  const location = useLocation();

  // Initialize Bootstrap Collapse once
  useEffect(() => {
    if (!collapseRef.current) return;

    bsCollapseRef.current = new Collapse(collapseRef.current, {
      toggle: false, // don't auto-toggle on init
    });

    return () => {
      // Bootstrap doesn't require explicit destroy in most cases,
      // but we'll clear refs for safety.
      bsCollapseRef.current = null;
    };
  }, []);

  // Close menu automatically when route changes (extra-safe)
  useEffect(() => {
    if (bsCollapseRef.current) {
      bsCollapseRef.current.hide();
    }
  }, [location.pathname]);

  const handleNavClick = () => {
    // Close only if it's currently open
    if (bsCollapseRef.current) {
      bsCollapseRef.current.hide();
    }
  };

  return (
    <nav
      className="navbar navbar-expand-lg navbar-dark"
      style={{
        background: "linear-gradient(90deg, #6f42c1, #8f6cfb)",
      }}
    >
      <div className="container">
        <NavLink className="navbar-brand fw-bold" to="/" onClick={handleNavClick}>
          AiW
        </NavLink>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#nav"
          aria-controls="nav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className="collapse navbar-collapse" id="nav" ref={collapseRef}>
          <ul className="navbar-nav ms-auto align-items-lg-center gap-lg-3">
            <li className="nav-item">
              <NavLink className="nav-link" to="/" onClick={handleNavClick}>
                Home
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                className="nav-link"
                to="/page/register"
                onClick={handleNavClick}
              >
                Register
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                className="nav-link"
                to="/page/login"
                onClick={handleNavClick}
              >
                Login
              </NavLink>
            </li>

            {/* Search icon */}
            <li className="nav-item">
              <button
                className="btn btn-link nav-link p-0 text-white"
                aria-label="Search"
                title="Search"
                onClick={handleNavClick}
              >
                <i className="bi bi-search fs-5" />
              </button>
            </li>

            {/* Join / Sign In CTA */}
            <li className="nav-item">
              <Link
                to="/page/login"
                onClick={handleNavClick}
                className="btn btn-light fw-semibold px-3"
                style={{ color: "#6f42c1" }}
              >
                Join / Sign In
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
